export const GET_JOBCODES_BEGIN = 'GET_JOBCODE_BEGIN'
export const GET_JOBCODES_SUCCESS = 'GET_JOBCODES_SUCCESS'
export const GET_JOBCODES_ERROR = 'GET_JOBCODES_ERROR'

export const DELETE_JOBCODE_BEGIN = 'DELETE_JOBCODE_BEGIN'
export const DELETE_JOBCODE_SUCCESS = 'DELETE_JOBCOD_SUCCESS'
export const DELETE_JOBCODE_ERROR = 'DELETE_JOBCODE_ERROR'

export const ADD_JOBCODE_BEGIN = 'ADD_JOBCODE_BEGIN'
export const ADD_JOBCODE_SUCCESS = 'ADD_JOBCODE_SUCCESS'
export const ADD_JOBCODE_ERROR = 'ADD_JOBCODE_ERROR'

export const UPDATE_JOBCODE_BEGIN = 'UPDATE_JOBCODE_BEGIN'
export const UPDATE_JOBCODE_SUCCESS = 'UPDATE_JOBCODE_SUCCESS'
export const UPDATE_JOBCODE_ERROR = 'UPDATE_JOBCODE_ERROR'
